export default __webpack_public_path__ + "img/5xx.e4d4a61d.svg";